export default function(editor: any, opt: any = {}) {
	const domc = editor.DomComponents;
    let componentName: string;
    let componentClass: string;
    let droppableWrapperSelector = '[data-gjs-type="wrapper"]';
    const traits = { 
        traits: [
            {
                name: 'id'
            },
            {
                label: 'Не обновлять',
                name: 'universal-block-not-update',
                type: 'checkbox'
            }
        ]
    };


}
